import React from "react";
import { CardHeader, Grid } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import { LoadingButton } from "@mui/lab";

const ThirdPartyDeliveryOptions = (props) => {
  const {
    shopWebsiteConfig,
    handleChange,
    handleSave,
    handleRestore,
    loadingButton,
  } = props?.shopWebsiteCustomization;
  const data = shopWebsiteConfig?.ThirdPartyDelivery;
  return (
    <Card className="bg-white shadow-sm">
      <CardHeader
        title={
          <div className="text-[#24211F] text-base font-bold">
            Third Party Delivery Options
          </div>
        }
      ></CardHeader>
      <div style={{ border: "1px solid #ccc" }}>
        <CardContent>
          <Grid container gap={1}>
            <Grid item xs={12}>
              <div className="flex  flex-row xs:flex-col justify-between ">
                <div className="flex justify-start w-6/12">
                  <img
                    src={"../../assets/images/DoorDash.svg"}
                    alt="DoorDash"
                    width={"34px"}
                    height={"26px"}
                  />
                  <p className="self-center text=[#24211F] text-base pl-1">
                    Door Dash
                  </p>
                </div>
                <div className="w-full">
                  <TextField
                    fullWidth
                    variant="outlined"
                    value={data?.vchDoorDashURL}
                    name="vchDoorDashURL"
                    id="vchDoorDashURL"
                    placeholder="Enter URL"
                    onChange={(e) =>
                      handleChange(
                        "ThirdPartyDelivery",
                        "vchDoorDashURL",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex justify-between">
                <div className="flex justify-start w-6/12">
                  <img
                    src={"../../assets/images/UberEats.svg"}
                    alt="UberEats"
                    width={"34px"}
                    height={"26px"}
                  />
                  <p className="self-center text=[#24211F] text-base pl-1">
                    Uber Eats
                  </p>
                </div>
                <div className="w-full">
                  <TextField
                    fullWidth
                    variant="outlined"
                    value={data?.vchUberEatsURL}
                    name="vchUberEatsURL"
                    placeholder="Enter URL"
                    onChange={(e) =>
                      handleChange(
                        "ThirdPartyDelivery",
                        "vchUberEatsURL",
                        e.target.value
                      )
                    }
                    id="vchUberEatsURL"
                  />
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex justify-between">
                <div className="flex justify-start w-6/12">
                  <img
                    src={"../../assets/images/GrubHub.svg"}
                    alt="GrubHub"
                    width={"34px"}
                    height={"26px"}
                  />
                  <p className="self-center text=[#24211F] text-base pl-1">
                    GrubHub
                  </p>
                </div>
                <div className="w-full">
                  <TextField
                    fullWidth
                    variant="outlined"
                    value={data?.vchGrubHubURL}
                    name="vchGrubHubURL"
                    id="vchGrubHubURL"
                    placeholder="Enter URL"
                    onChange={(e) =>
                      handleChange(
                        "ThirdPartyDelivery",
                        "vchGrubHubURL",
                        e.target.value
                      )
                    }
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </div>
      <CardActions
        sx={{ backgroundColor: "#FFF8F8", borderTop: "1px solid #C12637",height:'50px' }}
      >
        <Grid container>
          <Grid item xs={6}>
            <Button
              className="text-[#24211F] font-semibold"
              onClick={() => handleRestore("ThirdPartyDelivery")}
            >
              Restore
            </Button>
          </Grid>
          <Grid item xs={6} container justifyContent={{ xs: "right" }}>
            <LoadingButton
              variant="outlined"
              disabled={loadingButton === "ThirdPartyDelivery" ? true : false}
              loading={loadingButton === "ThirdPartyDelivery" ? true : false}
              onClick={() => handleSave("ThirdPartyDelivery")}
              className="text-[#C12637] font-semibold bg-white border-[#C12637]"
            >
              Save
            </LoadingButton>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default ThirdPartyDeliveryOptions;
